import dayjs from 'dayjs';

/** Placeholder exibido quando uma data está ausente/inválida. */
export const EMPTY_BANNER_DATE = '—';

/**
 * Formata uma data de banner (ISO date-time) para `DD/MM/AAAA`.
 *
 * Usa apenas a parte de data (`YYYY-MM-DD`) para preservar o dia do calendário,
 * evitando o deslocamento de fuso que ocorreria ao converter o horário UTC para
 * o fuso local (ex.: `2025-06-30T00:00:00Z` viraria `29/06` em UTC-3).
 *
 * @param value - Data em string (date-time) vinda da API, ou nula.
 * @returns Data formatada, ou `—` quando ausente/inválida.
 *
 * @example
 * ```ts
 * formatBannerDate('2017-03-08T00:00:00Z'); // '08/03/2017'
 * formatBannerDate(null); // '—'
 * ```
 */
export function formatBannerDate(value: string | null | undefined): string {
  if (!value) return EMPTY_BANNER_DATE;
  const parsed = dayjs(value.slice(0, 10));
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : EMPTY_BANNER_DATE;
}
